class recentlyProducts extends HTMLElement {
    constructor() {
      super();
      this.recentlyViewed = [];
      this.container = document.querySelector('.recently-viewed-main');

      this.manageRecentlyViewed();
    }
    
    manageRecentlyViewed(){
      let getRecentlyViewed = localStorage.getItem("user_recently_viewed");
      if (getRecentlyViewed != null) {
        this.recentlyViewed = JSON.parse(getRecentlyViewed);        
        this.recentlyViewed.reverse();

        if(this.recentlyViewed.length > 0) this.showRecentlyViewed(this.recentlyViewed);
      }
      
      if(window.globalSpace.template == 'product' && window.globalSpace.product.price > 0){
        const productData = window.globalSpace.product;
        let requiredData = {
          id: productData.id,
          handle: productData.handle,
          title: productData.title,
          price: productData.price,
          compared_at_price: productData.compare_at_price,
          image: productData.featured_image,
          tags: productData.tags,
          reviews_count: window.globalSpace.reviews_count
        }
        this.addToRecentlyViewed(requiredData);
      }
    }

    showRecentlyViewed(products) {
      let recentlyViewedHTML = '';
      let totalProducts = 0;
      products.forEach(product => {
        
        
        const currentProduct = window.globalSpace.product?.id || '123';
        const currentIndex = product.id == currentProduct;
        const productTags = product.tags;

        let discountPercentage = 0;
        if(product.compared_at_price > product.price){
          discountPercentage = Math.floor(((product.compared_at_price - product.price) / product.compared_at_price) * 100);
        }

        if(currentIndex == false && product.price > 0){
          totalProducts += 1;
          recentlyViewedHTML += ` <swiper-slide>
            <div class="card card-product card-product-style-1 text-start rounded-0 border-0">
              <div class="product--media product-images-wrapper mb-3 position-relative">
                <div class="product--media square">
                <span class="badges">
                    ${productTags?.includes('Lab Grown Diamond') || productTags?.includes('Lab Grown Diamond') ? `<span class="badge badge-best-seller">${window.badgeStrings.lab_grown_diamond}</span>` : ''}
                    ${productTags?.includes('moissanite') || productTags?.includes('moissanite') ? `<span class="badge badge-new">${window.badgeStrings.moissanite}</span>` : ''}
                  </span>
                  <a href="/products/${product.handle}" class="d-block product-link position-relative">
                    <img src="${product.image}" alt="${product.title}">
                  </a>
                </div>
              </div>
              <div class="card-body bg-white ps-0 pe-0">
                <a href="/products/${product.handle}" class="h2 d-block mb-1 card-product-title fs-base left text-start fw-semibold text-math-auto">${product.title}</a>
                <div class="price-block mb-4 text-left">
                  <div class="product-price-selector d-flex flex-wrap align-items-center gap-1 justify-content-between">
                    <div class="gap-1 d-flex flex-wrap align-items-end" id="product-price-selector">
                        <span class="price m-0 p-0 money" data-currentprice="">${Utility.formatMoney(product.price, window.globalSpace.money_format)}</span>
                        ${product.compared_at_price > product.price ? `<del class="price small m-0 p-0 money d-inline-block compare-price" data-compareprice="">${Utility.formatMoney(product.compared_at_price, window.globalSpace.money_format)}</del>` : ''}
                    </div>
                    ${discountPercentage > 0 ? `<span class="discount-percentage text-primary-500 bg-primary-200 rounded fs-md fw-semibold d-inline-block">Save ${discountPercentage}%</span>` : ''}
                  </div>
                   <div class="pdp-star-rating d-flex align-items-center gap-1 fs-md">
                      ${product.reviews_count != null || product.reviews_count != undefined ? `<div class="">${product.reviews_count}</div>` : ''}
                    </div>
                  </div> 
                </div>
              </div>
            </div>
          </swiper-slide>`;
        }
      });

      if(totalProducts > 0){
        let sliderHTML = `<swiper-container class="recentlyViewe--swiper"
          slides-per-view="2"
          space-between="15"
          loop="false"
          grabCursor="true"
          navigation='{
            "nextEl": ".button-next-recently-viewed",
            "prevEl": ".button-prev-recently-viewed"
          }'
          >${recentlyViewedHTML}
          </swiper-container>
                    <div class="custom-swiper-navigation inside">
            <button class="swiper-button-prev button-prev-recently-viewed"><svg aria-hidden="true" focusable="false"><use href="#icon-arrow-left"></use></svg></button>
            <button class="swiper-button-next button-next-recently-viewed"><svg aria-hidden="true" focusable="false"><use href="#icon-arrow-right"></use></svg></button>
          </div>`

        this.container.classList.remove('d-none');
        this.container.querySelector("recently-products").innerHTML = sliderHTML;
      }
    }

    addToRecentlyViewed(product) {
      const productExist = this.recentlyViewed.findIndex((x) => {
        return x.id == product.id;
      });

      if (productExist == -1) {
        this.recentlyViewed.push(product)
        localStorage.setItem(
          "user_recently_viewed",
          JSON.stringify(this.recentlyViewed)
        );
      }
    }
}
customElements.define("recently-products", recentlyProducts);

// Update Swiper slider breakpoints

const swiperRecentlyViewedEl = document.querySelector('.recentlyViewe--swiper'); 
const swiperRecentlyViewed = {
  breakpoints: {
      560: {
          slidesPerView: 2.5,
          spaceBetween: 20,
      },
      768: {
          slidesPerView: 3.1,
          spaceBetween: 30,
      },
      992: {
          slidesPerView: 3.6,
          spaceBetween: 30,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 30,
      }
  },
  on: {
    init() {
      
    },
  },
};
Object.assign(swiperRecentlyViewedEl, swiperRecentlyViewed);
swiperRecentlyViewedEl.initialize();